export const USER_REQUEST = 'USER_REQUEST'
export const USER_SUCCESS = 'USER_SUCCESS'
export const USER_ERROR = 'USER_ERROR'
export const USER_CLOSE_PROFILE_MODAL = 'USER_CLOSE_PROFILE_MODAL'
export const USER_TOKEN = 'USER_TOKEN'
